<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">

        <section slot="content" class="gz-form gz-form_white">
            <AddServiceEntityForm />
        </section>        

    </gz-auth-view-template>
</template>

<script>
import AddServiceEntityForm from '@/components/custom/admin/views/service-entity/ServiceEntityAddForm'

export default {
    name: 'ServiceEntitySingleInfo',

    components: {
        AddServiceEntityForm
    }
}
</script>